import Axios from "axios";
import {
  SET_CASH_BOOK_REPORT,
  UNSET_CASH_BOOK_REPORT,
} from "@/store/mutation-types";
import {
  getCashBookReport,
} from "@/store/api";

const state = {
  cashBookReport: [],
};

const getters = {
  getCashBookReport(state) {
    return state.cashBookReport;
  },
};

const mutations = {
  [SET_CASH_BOOK_REPORT](state, data) {
    state.cashBookReport = data;
  },
  [UNSET_CASH_BOOK_REPORT](state) {
    state.cashBookReport = [];
  },
};

const actions = {
  getCashBook({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.get(`${getCashBookReport}`, { params: data })
        .then((response) => {
          commit(SET_CASH_BOOK_REPORT, response.data.data || []);
          resolve(response.data);
        })
        .catch((error) => {
          commit(UNSET_CASH_BOOK_REPORT);
          // Return error response structure for consistent handling
          const errorResponse = {
            success: false,
            message: error.response?.data?.message || error.message || 'Failed to load cash book report',
            data: null
          };
          resolve(errorResponse);
        })
        .finally(() => {
          commit("UNSET_LOADING", null, { root: true });
        });
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};

